import React from 'react';
import PosOpenOrderingPage from '../modules/posRestaurant/components/PosOpenOrderingPage';

const PosOpenOrderingPublicPage = () => {
  return <PosOpenOrderingPage />;
};

export default PosOpenOrderingPublicPage;

